import React, { Component } from "react";
import Step1 from "./step1";
import Step2 from "./step2";
import Step3 from "./step3";
import api from "../../api";

import { ROUTE_NAMES } from "../../Routes/routes";
import { storageServices } from "../../services/storage";

export default class InitialSetup extends Component {
  constructor(props) {
    super(props);
    var user = storageServices.getCurrentUser();
    console.log("user",user)  
    this.state = {
      activeStep: 1,
      id: user?._id,
      email: user?.email,
      profile: user?.profile,
      terms_acceptance: true,
      loading: false,
      biz_id: "",
      biz_title: "",
      biz_type: "",
      biz_channel: "",
      biz_logo: "",
      facebook: {
        page_id: "",
        app_id: "",
        app_secret_key: "",
        image: "",
      },
      default_biz_rules:""
    };
    console.log("state",this.state)
    this.Step1 = Step1.bind(this);
    this.Step2 = Step2.bind(this);
    this.Step3 = Step3.bind(this);
  }

  componentDidMount() { 
    api.getDefaultMetricsById("business_rules").then(
      (res) => {
        console.log("getDefaultMetricsById:", res);
        let default_biz_rules = res?.data?.data;
        delete default_biz_rules?._id;
        this.setState({default_biz_rules:default_biz_rules});
        console.log("default_biz_rules",this.state.default_biz_rules)
    
      },
      (error) => {
        console.log("error", error);
      }
    );


  }
  handleNextPrev = (val) => {
    const { activeStep } = this.state;
    let updatedActiveStep = activeStep + val;
    updatedActiveStep =
      updatedActiveStep < 1 ? 1 : updatedActiveStep > 3 ? 3 : updatedActiveStep;
    this.setState({ activeStep: updatedActiveStep });
  };

  handleChange = (event) => {
    try {
      const { name, value } = event.target;

      if (name == "biz_title") {
        var _biz_id = value.trim().toLowerCase().replace(/ /g, '');
        this.setState({ biz_id: _biz_id });
      }

      this.setState({ [name]: value });
    } catch (error) {
      console.log(error);
    }
  };

  handleFacebook = (event) => {
    try {
      const { name, value } = event.target;
    
      if (name == "page_id") {
        this.handleFbPage(value);
      }

  
    
      this.setState((prevState) => ({
        facebook: {
          ...prevState.facebook,
          [name]: value,
        },
      }));
    

      //this.setState({ [name]: value })
    } catch (error) {
      console.log(error);
    }
  };

  handleFbPage = async (page_id) => {
    await api.getFbPageImage(page_id).then(
      (res) => {
        console.log("Response:", res);
        var data = res.data;

        this.setState({ facebook: { image: data?.data?.url } });
        this.setState({ biz_logo: data?.data?.url });
      },
      (error) => {
        console.log("error", error);
        alert(error);
      }
    );
  };

  handleSubmit = async (event) => {
    event.preventDefault();
  
    // this.setState({ loading: true })
    // const { email, password } = this.state;
    const { history } = this.props;
    
    let biz_rules = this.state.default_biz_rules
    biz_rules['biz_id']=this.state.biz_id;
    biz_rules['biz_title']=this.state.biz_title;

    try {
      await api.updateCustomerById(this.state.id, this.state).then(
        (res) => {
          console.log("Response:", res);
          // history.push(ROUTE_NAMES.dashboard);
        },
        (error) => {
          console.log("error", error);
          this.setState({ loading: false });
        }
      );

      await api.insertBusinessRules(biz_rules).then(
        (res) => {
          console.log("insertBusiness rules:", res);
        },
        (error) => {
          console.log("error", error);
          this.setState({ loading: false });
        }
      );


      await api.insertBusiness(this.state).then(
        (res) => {
          console.log("insertBusiness:", res);

          console.log("Final state:", this.state);
        storageServices.setCurrentUser(this.state)

  
          alert("Setup completed successfully! Your brand id is :" + this.state.biz_id)

         history.push(ROUTE_NAMES.home);
        },
        (error) => {
          console.log("error", error);
          this.setState({ loading: false });
        }
      );



    

    




    } catch (error) {
      this.setState({ loading: false });
      alert(error);
    }
  };

  render() {
    const { activeStep, loading } = this.state;
    return (
      <div>
        <div className="d-flex align-items-center auth px-0 bg-gradient-primary">
          <div className="row w-100 mx-0">
            <div className="col-lg-4 mx-auto">
              <div className="auth-form-light text-left py-5 px-4 px-sm-5">
                <div className="brand-logo text-center">
                  <h3 className="page-title text-primary">
                    <span className=" mr-2">
                      <i className="mdi mdi-hand-pointing-right"></i>
                    </span>{" "}
                    Get started{" "}
                  </h3>
                </div>

                <div className="gs-content">
                  {activeStep === 1 && this.Step1()}
                  {activeStep === 2 && this.Step2()}
                  {activeStep === 3 && this.Step3()}

                  <div className="mt-3 row">
                    <div className="mx-auto">
                      <button
                        type="button"
                        className="btn btn-gradient-primary btn-rounded btn-icon mr-3"
                        onClick={() => this.handleNextPrev(-1)}
                      >
                        <i className="mdi mdi-skip-previous"></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-gradient-primary btn-rounded btn-icon"
                        onClick={() => this.handleNextPrev(+1)}
                      >
                        <i className="mdi mdi-skip-next"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
